import { LeagueProfile } from '../types/league';
import { Profile } from '../types/player';

export const getSubscriptionPlan = (profile: Profile | LeagueProfile) => {
  if (!profile?.subscription || !profile.subscription?.planName) return 'free';
  const { subscription } = profile;
  return subscription.planName;
};
